import { apiClient } from "./apiclient";

// CREATE Project Module
export const createProjectModule = (data, token) =>
  apiClient.post("/project-modules", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

// GET All Project Modules
export const getAllProjectModules = (token) =>
  apiClient.get("/project-modules", {
    headers: { Authorization: `Bearer ${token}` },
  });

// UPDATE Project Module
export const updateProjectModule = (id, data, token) =>
  apiClient.put(`/project-modules/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });


// GET Active Sprint Stories
export const getActiveSprintStories = (token) =>
  apiClient.get("/stories/active", {
    headers: { Authorization: `Bearer ${token}` },
  });

  // GET Stories by Project Module Id (SubModule dropdown)
export const getStoriesByProjectModuleId = (moduleId, token) =>
  apiClient.get(`/project-modules/${moduleId}/stories`, {
    headers: { Authorization: `Bearer ${token}` },
  });

 export const getModuleById = (id, token) =>
  apiClient.get(`/project-modules/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
